import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Alert, Button, Col, Empty, Icon, Input, message, Popconfirm, Row, Spin, Table} from 'antd';
import './contacts.scss';
import AnimateEnter from '../AnimateEnter';
import {CONTACTS_GROUPS_RESOURCE_NAME} from '../../config/constants';
import {allContactsGroupsColumns} from './columns/allContactsGroupsColumns';
import {withCancellablePromise} from '../../hocs/withCancellablePromise';
import {_callResource} from '../../context/_callResource';
import {ApiError} from '../../utils/errors';
import TEXTS from "../../locale/texts";
import MESSAGES from "../../locale/messages";

class AllContactsGroups extends Component {
  state = {
    isLoading: true,
    isLoadingDelete: false,
    showBlackList: false,
    selectedRows: [],
    isMounted: true,
    pageSize: 20,
    filter: '',

    // contacts groups resource
    contactsGroupsData: [],
    contactsGroupsDataIsLoading: true,
    contactsGroupsDataError: null,

    // contacts groups delete resource
    contactsGroupsDeleteIsLoading: false,
    contactsGroupsDeleteError: false,

    // contacts export resource
    contactsGroupsExportIsLoading: false,
    contactsGroupsExportError: false,
  };

  callResource = _callResource.bind(this);
  columns = allContactsGroupsColumns.bind(this);

  rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      this.setState({ selectedRows });
    }
  };

  getAllGroupsData = () => {
    const { promiseCancelToken } = this.props;
    this.setState({ selectedRows: [] });
    this.callResource({
      resourceName: CONTACTS_GROUPS_RESOURCE_NAME,
      apiClassName: 'contactsGroups',
      action: 'get',
      promiseCancelToken
    });
  };

  componentDidMount() {
    this.getAllGroupsData();
  };

  createContactGroup = () => {
    this.props.history.push('/phonebook/groups/create');
  };

  onShowBlackList = (checked) => {
    this.setState({
      showBlackList: checked
    });
  };

  onDelete = () => {
    const { promiseCancelToken, addNotification, lang } = this.props;
    const { selectedRows } = this.state;
    const ids = selectedRows.map(({ id }) => id);
    const n = ids.length;
    this.callResource({
      resourceName: CONTACTS_GROUPS_RESOURCE_NAME,
      apiClassName: 'contactsGroups',
      action: 'delete',
      apiCallParams: { ids },
      promiseCancelToken,
      onSuccess: () => {
        this.setState({ selectedRows: [] });
        addNotification(MESSAGES.groupsAreDeleted(n)[lang]);
        this.getAllGroupsData();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        const msg = n === 1
          ? TEXTS.couldNotDeleteOneGroup[lang]
          : TEXTS.couldNotDeleteGroups[lang];
        message.error(`${msg}: ${errorMessage}.`, 5);
      }
    });
  };
  exportGroupContact = () => {
    const ids = this.state.selectedRows.map(({ id }) => id);
    const count = ids.length;
    const { promiseCancelToken, lang } = this.props;
    this.callResource({
      resourceName: CONTACTS_GROUPS_RESOURCE_NAME,
      apiClassName: 'contactsGroups',
      action: 'download',
      apiCallParams: { ids },
      promiseCancelToken,
      notification: {
        text: MESSAGES.contactsGroupAreExported(count)[lang]
      }
    });
  };

  handleChangeFilter = ({ target: { value: filter } }) => {
    this.setState({ filter });
  };

  resetSearch = () => {
    this.setState({ filter: '' });
  };

  renderData = () => {
    const { lang } = this.props;
    const {
      pageSize,
      isMounted,
      filter,
      contactsGroupsData,
      contactsGroupsDataError,
    } = this.state;

    if (contactsGroupsDataError) {
      const { errorTitle, errorMessage } = contactsGroupsDataError;
      return (
        <Alert
          message={errorTitle}
          description={errorMessage}
          type="error"
        />
      );
    }

    const _contacts = contactsGroupsData && contactsGroupsData.items;
    const columns = this.columns(lang);

    const contacts = (_contacts && filter) ? _contacts.filter(({ name }) => {
      const matcher = new RegExp(`${filter}`, 'ig');
      return name.match(matcher);
    }) : _contacts;

    return (
      (
        <AnimateEnter paginationAnimate={{ isMounted }}>
          <Table
            columns={columns}
            dataSource={contacts}
            rowSelection={this.rowSelection}
            rowKey={({ id }) => id}
            pagination={{
              pageSize: pageSize,
              hideOnSinglePage: true,
              size: 'large',
              onChange: (page) => {
                window.scrollTo(0, 172);
                this.setState({
                  currentPage: page,
                  isMounted: false
                });
                setTimeout(() => {
                  this.setState({ isMounted: true });
                }, 0);
              }
            }}
          />
        </AnimateEnter>
      )
    );
  };

  render() {
    const { lang } = this.props;
    const {
      selectedRows,
      filter,
      contactsGroupsDataIsLoading,
      contactsGroupsDeleteIsLoading,
      contactsGroupsExportIsLoading
    } = this.state;

    return (
      <div>
        <section className="submenu bg-white table-header all-contacts">
          <Row gutter={16} type="flex" justify="space-between">
            <Col xs={24} sm={24} md={24} lg={5} xl={5} xxl={5}>
              <Button
                block
                className="mr-3"
                size="large"
                icon="usergroup-add"
                onClick={this.createContactGroup}
              >
                {TEXTS.btnCreateGroup[lang]}
              </Button>
            </Col>
            <Col xs={24} sm={24} md={24} lg={5} xl={5} xxl={5}>

              <Popconfirm
                placement="bottom"
                title={TEXTS.areYouSureToDeleteChosenContactGroups[lang]}
                okText={TEXTS.yes[lang]}
                cancelText={TEXTS.btnToCancel[lang]}
                onConfirm={this.onDelete}
                disabled={selectedRows.length === 0 || contactsGroupsDeleteIsLoading}
              >
                <Button
                  block
                  className="mr-3"
                  size="large"
                  icon="usergroup-delete"
                  ghost={selectedRows.length > 0 && !contactsGroupsDeleteIsLoading}
                  type="danger"
                  loading={contactsGroupsDeleteIsLoading}
                  disabled={selectedRows.length === 0 || contactsGroupsDeleteIsLoading}
                >
                  {TEXTS.btnDeleteGroup[lang]}
                </Button>
              </Popconfirm>
            </Col>
            <Col xs={24} sm={24} md={24} lg={5} xl={5} xxl={5}>
              <Button
                block
                className="mr-3"
                size="large"
                type="default"
                icon='export'
                disabled={selectedRows.length === 0 || contactsGroupsExportIsLoading}
                onClick={this.exportGroupContact}
                loading={contactsGroupsExportIsLoading}
              >
                {TEXTS.btnExportContacts[lang]}
              </Button>
            </Col>
            <Col xs={24} sm={24} md={24} lg={9} xl={9} xxl={9}>
              <Input
                prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }}/>}
                allowClear
                size="large"
                value={filter}
                placeholder={TEXTS.searchGroupPlaceholder[lang]}
                onChange={this.handleChangeFilter}
              />
            </Col>
          </Row>
        </section>
        <section className='all-campaigns'>
          {contactsGroupsDataIsLoading
            ? <Empty description={TEXTS.dataIsLoading[lang]}>
              <div style={{ marginTop: 15, textAlign: 'center' }}>
                <Spin spinning={true}/>
              </div>
            </Empty>
            : this.renderData()}
        </section>
      </div>
    )
  }
}

export default withCancellablePromise(withRouter(AllContactsGroups), 'getAllContactsGroups');
